import { useMutation } from '@tanstack/react-query'
import { deleteBatch } from '../../services'
import { BatchesMutationKeys } from '@/modules/batches/keys'
import { UseBaseMutationOptions } from '@/core/api/type'

export default function useMutationDeleteBatch(
	props?: UseBaseMutationOptions<void, string>,
) {
	return useMutation({
		mutationKey: [BatchesMutationKeys.DeleteBatch],
		mutationFn: deleteBatch,
		...props,
	})
}
